<template>
  <div @click.stop="openDialog">
    <el-row
      v-if="act"
      :class="['response-act', actInfo.status, { 'text-align-left': value }]"
    >
      <el-badge
        :class="actInfo.isBadge ? 'act-badge' : ''"
        v-html="actInfo.text"
      />
    </el-row>
    <div v-else class="response-act danger">АКТ</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Act',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    onActClick: {
      type: Function,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getAct: 'reports/getReportModal',
    }),
    act() {
      const acts = this.getAct(this.response.id, 'acts')

      return acts.find(c => c.files.length) || acts[0]
    },
    actInfo() {
      if (!this.act) {
        return ''
      }
      const label = this.value ? '<span class="label">Акт:</span> ' : 'АКТ '
      const { number, document_create_date, files, pc_api_transactions } =
        this.act
      const day = this.dateToFormat(
        document_create_date,
        'shortDateWithoutYear',
      )
      const text = `${label}${number || '-'} от ${day || '-'}`
      const isBadge = pc_api_transactions && Boolean(pc_api_transactions.length)
      let status = 'danger'

      if (number && document_create_date && files.length) {
        status = 'success'
      } else if (number && document_create_date && !files.length) {
        status = 'warning'
      }

      return { text, status, isBadge }
    },
  },
  methods: {
    openDialog() {
      this.onActClick(this.response)
    },
  },
}
</script>

<style lang="sass">
.text-align-left
  text-align: left !important
.report-response-item
  & .response-act
    font-weight: bold
    position: relative
    text-align: center
    font-size: 14px
    & .label
      color: #A4A4A4
    &:first-child
      margin-top: 0
    &.danger
      color: #f00
    &.warning
      color: #ffb800
    &.success
      color: #00bf40
    .act-badge
      &:after
        content: ''
        position: absolute
        background: url('~@/assets/img/sign-badge.png')
        width: 13px
        height: 15px
        top: -10px
        right: -10px
        background-size: cover
</style>
